import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { GYPSUM, OLAF } from 'HubStyleTokens/colors';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import UITypeahead from 'UIComponents/typeahead/UITypeahead';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
const StyledTypeahead = styled(UITypeahead).withConfig({
  displayName: "MobileTypeaheadResults__StyledTypeahead",
  componentId: "sc-1kp2qo4-0"
})(["&&{width:100%;.mobile-typeahead-search-results{padding-top:16px;max-height:unset;background-color:", ";z-index:", ";ul[role='listbox']{.mobile-typeahead-item{padding-left:0;}}.mobile-typeahead-group{background-color:", ";}}}"], OLAF, URANUS_LAYER, GYPSUM);
StyledTypeahead.displayName = 'StyledTypeahead';

const Spinner = () => {
  return /*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true
  });
};

function getMappedOptions(options) {
  return options.map(option => {
    if ('options' in option) {
      return Object.assign({}, option, {
        dropdownClassName: classNames(option.dropdownClassName, 'mobile-typeahead-group'),
        options: getMappedOptions(option.options)
      });
    }

    return Object.assign({}, option, {
      dropdownClassName: classNames(option.dropdownClassName, 'mobile-typeahead-item')
    });
  });
}

const MobileTypeaheadResults = (_ref) => {
  let {
    className,
    loading,
    onChange,
    open = true,
    options
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "loading", "onChange", "open", "options"]);

  const mappedOptions = useMemo(() => getMappedOptions(options), [options]);
  const TypeaheadItem = useCallback((_ref2) => {
    let {
      children,
      option
    } = _ref2,
        rest = _objectWithoutPropertiesLoose(_ref2, ["children", "option"]);

    return /*#__PURE__*/_jsx("li", Object.assign({}, rest, {
      onClick: () => {
        onChange(option);
      },
      children: children
    }));
  }, [onChange]);
  return /*#__PURE__*/_jsx(StyledTypeahead, Object.assign({}, props, {
    className: className,
    hideResults: !open,
    itemComponent: loading ? Spinner : TypeaheadItem,
    options: loading ? [] : mappedOptions,
    resultsClassName: "mobile-typeahead-search-results",
    searchClassName: "hidden"
  }));
};

export default MobileTypeaheadResults;